module.exports = __webpack_public_path__ + "img/skin-pigmentation.3505cc06.svg";